import { deserialize } from 'libs/cerialize';

export class ParentAssemblyModel {
	@deserialize
	Id: string;

	@deserialize
	Name: string;
}